// src/pages/Features.jsx
import React from 'react';

const Features = () => {
    // Função para redirecionar para o WhatsApp
    const redirectToWhatsapp = () => {
        const message = `Olá, gostaria de saber mais sobre as funcionalidades oferecidas!`;
        const whatsappUrl = `https://wa.me/5585982007804?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="w-full bg-gradient-to-b from-purple-100 via-purple-200 to-white py-12 mt-12">
            <h2 className="text-center text-4xl font-bold text-purple-600 mb-8">Funcionalidades</h2>
            <div className="grid md:grid-cols-3 gap-8 px-8">
                {/* Funcionalidade 1 */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Automação Inteligente</h3>
                    <p className="text-sm text-gray-600 mt-4">Automatize interações com clientes, otimizando sua equipe e oferecendo um atendimento eficiente 24/7.</p>
                </div>

                {/* Funcionalidade 2 */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Integração com CRM</h3>
                    <p className="text-sm text-gray-600 mt-4">Gerencie leads e dados de clientes em tempo real com integração direta aos principais CRMs do mercado.</p>
                </div>

                {/* Funcionalidade 3 */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Relatórios Avançados</h3>
                    <p className="text-sm text-gray-600 mt-4">Obtenha relatórios detalhados de desempenho com insights para otimizar suas estratégias de vendas.</p>
                </div>
            </div>

            {/* Botão Saiba Mais Centralizado entre os Cards */}
            <div className="w-full mt-10 text-center">
                <button
                    className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-8 rounded-full shadow-lg transform transition-transform duration-300 hover:scale-105"
                    onClick={redirectToWhatsapp}
                    style={{ width: '40%' }}
                >
                    Saiba Mais
                </button>
            </div>
        </div>
    );
};

export default Features;
